import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthorityStorageService {

  storageKey = "authority";

  constructor() { }

  storeAuthority(authority) {
    localStorage.setItem(this.storageKey, authority);
  }
 
  loadAuthority() {
    return localStorage.getItem(this.storageKey);
  }
  clear() {
    localStorage.removeItem(this.storageKey);
  }
}
